<app-ace-select [appendTo]="DROPDOWN_HOLDER_SELECTOR"
                [items]="options"
                [bindValue]="valueKey"
                [bindLabel]="labelKey"
                [placeholder]="placeholder() ?? ('Rule State' | messageTranslate)"
                [multiSelect]="multiSelect()"
                [hideSelected]="false"
                [maxSelectedLabels]="this.maxSelectedLabels()"
                [maxSelectedShowItemName]="true"
                [maxSelectedItemName]="{messageKey: 'rule states'}"
                [showClearItem]="true"
                [truncateLabels]="true"
                (openEvent)="onOpenEvent($event)"
                (closeEvent)="onCloseEvent($event)"/>
